import * as actionTypes from '../actions/actionTypes';

const initialState = {
  data: {},
  loading: false,
};

const reducer = (state = initialState, action) => {
  let data;

  switch (action.type) {
    case actionTypes.TAGS_STORE:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.TAGS_STORE_SUCCESS:
      data = {
        ...state.data,
        [action.payload.callId]: action.payload.tags,
      };

      return {
        ...state,
        data,
        loading: false,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;
